@let isSlideoutOpen = layoutStore.presentFiltersSg();

@if (isSlideoutOpen) {
  <atn-ds-slideout-overlay name="Filters">
    <i
      actions
      class="atn-icon atn-close atn-red"
      (click)="layoutStore.patchState({ presentFilters: false })"
    ></i>

    <div class="atn-filters-slideout">
      <atn-ds-select-multiple
        label="Assignments Type"
        [items]="filters"
        [(value)]="selectedFiltersSg"
      />
    </div>
  </atn-ds-slideout-overlay>
}
